import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppRoutes } from '../../app-routes'
import { LOGIN_PATH, REGISTER_PATH } from '../../constants/RoutePaths'
import userManager from '../../helpers/UserManager'

const LoginRedirect = () => {
  const history = useNavigate()

  useEffect(() => {
    const getUser = async () => {
      const callbackUser = await userManager.configuration.signinRedirectCallback()

      const user = await userManager.getUserWhenLogin()

      const savedPath = callbackUser?.state || user?.state

      if (savedPath && savedPath !== LOGIN_PATH) {
        userManager.configuration.startSilentRenew()
        history(savedPath)
      } else if (user) {
        history(AppRoutes.ASSET_LIST)
      } else if (window.location.pathname.includes(REGISTER_PATH)) {
        history(REGISTER_PATH)
      } else {
        history(LOGIN_PATH)
      }
    }

    getUser().catch(() => {
      userManager.signIn()
    })
  }, [])

  return <></>
}

export default LoginRedirect
